<template>
    <div class="account">
        <div class="top wbg">
            <a-row :gutter="40" type="flex">
                <a-col :span="4" class="col">
                    <label>账号名称：</label>
                    <a-input v-model="form.username" placeholder="请输入账号名称" style="width:100%;"></a-input>
                </a-col>
                <a-col :span="5" class="col">
                    <label>操作内容：</label>
                    <a-input v-model="form.title" placeholder="请输入操作内容" style="width:100%;"></a-input>
                </a-col>
                <a-col :span="5" class="col">
                    <label>操作方式：</label>
                    <a-select style="width: 100%;" class="select" v-model='form.action' placeholder="请选择操作方式">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option value="add">添加</a-select-option>
                        <a-select-option value="edit">修改</a-select-option>
                        <a-select-option value="del">删除</a-select-option>
                    </a-select>
                </a-col>
                <a-col :span="7" class="col">
                    <label>操作时间：</label>
                    <timePick style="width: 100%;" @PickTime="PickTime" ref="timePicker"></timePick>
                </a-col>
                <a-col :span="3" class="col">
                    <a-button type="primary" icon="search" @click="form.page = 1; query()" style="margin-right:20px;height: 32px;">查询</a-button>
                    <a-button @click="reset" style="margin-right:20px;height: 32px;">重置</a-button>
                </a-col>
            </a-row>
        </div>
        <div class="tcon wbg">
            <div class="tableList">
                <table class="table" style="table-layout: fixed;">
                    <thead class="thead">
                        <td width='60'>序号</td>
                        <td width='200'>操作内容</td>
                        <td width='80'>账号名称</td>
                        <td width='80'>操作方式</td>
                        <td width='80'>ip地址</td>
                        <td width='84'>操作时间</td>
                    </thead>
                    <tbody>
                        <tr v-for='(i, index) in list' :key='i.id'>
                            <td>{{ 10 * (form.page - 1) + index + 1 }}</td>
                            <td><span class="curpoter" @click='dbclick(i)'> {{ i.title }}</span> </td>
                            <td>
                                <p>
                                    {{ i.username || '/' }}
                                </p>
                            </td>
                            <td>
                                <p>
                                    <font color='#3eab09' v-if='i.action == "add"'>添加</font>
                                    <font color='#ff9900' v-if='i.action == "edit"'>修改</font>
                                    <font color='#f00' v-if='i.action == "del"'>删除</font>
                                </p>
                            </td>
                            <td>
                                <p>
                                    {{ i.ip }}
                                </p>
                            </td>
                            <td>
                                <p>
                                    {{ i.update_time }}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="pages" v-if="count > 10">
                    <a-pagination v-model="form.page" show-quick-jumper :total="count" show-less-items :pageSize='10'
                        @change='turnpage' />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getAccount, changeAuditTime } from '@/server/user'
import { getAccuserAll, causeStepLog } from '@/server/api'
export default {
    data() {
        return {
            accuserList: [],
            list: [],
            count: 0,
            auditTime: '',
            form: {
                title: '',
                stime: '',
                action: '',
                etime: '',
                username: '',
                page: 1,
                limit: 10
            },
            modalVisible: false,
        }
    },
    filters: {

    },
    created() {
        this.query()
    },
    mounted() {
        let _this = this
        document.onkeydown = function (e) {
            if (e.keyCode == 13) {
                _this.query()
            }
        }
    },
    methods: {
        dbclick(record) {
            if (this.$common.AUTH('debtor:info')) {
                if (record.debtor_id) {
                    let routeUrl = this.$router.resolve({ "name": "lydetails", params: { "id": record.debtor_id } });
                    window.open(routeUrl.href, '_blank');
                }

            }
            else {
                this.$message.error({ content: '暂无权限', key: 'updatable' });
            }
        },
        PickTime(e) {
            if ("stime" in e) {
                this.form.stime = e.stime
            }
            else {
                this.form.etime = e.etime
            }
        },
        turnpage(val) {
            this.form.page = val;
            this.query()
        },
        reset() {
            this.form.limit = 10
            this.form.page = 1
            this.form.title = '',
            this.form.action = '',
            this.form.etime = '',
            this.form.username = '',
            this.form.stime = '',
            this.form.stime = '',
            this.form.etime = '',
            this.$refs.timePicker.clearTime()
            this.query()
        },
        query() {
            const form = JSON.parse(JSON.stringify(this.form))
            causeStepLog(form).then((res) => {
                this.list = res.list;
                this.count = res.count
            })
        }
    }
}
</script>
<style lang="less" scoped>
.col {
    display: flex;
    align-items: center;

    label {
        white-space: nowrap;
    }
}

.account {
    .top {
        padding: 20px;

        .group {
            display: flex;
            align-items: center;
        }

        .to {
            display: inline-block;
            width: 20px;
            height: 1px;
            margin: 0 10px;
            background-color: #dbdcde;
            vertical-align: middle;
        }

        form {
            width: 100%;
        }

        .label {
            display: inline-block;
            margin-right: 60px;
            font-size: 14px;
            color: #0e2949;
        }

        .btns {
            float: right;

            button {
                margin-left: 20px;
                min-width: 90px;
            }
        }
    }
}

// .ant-btn {
//     border-color: #1d8bfe;
//     color: #1d8bfe;
// }

.ant-btn-primary {
    color: #ffffff;
    border-color: #1d8bfe;
    background-color: #1d8bfe;
}

.tcon {
    padding: 0 20px;
    min-height: 760px;

    .tableList {
        width: 100%;

        .table {
            thead {
                td {
                    padding-left: 0;

                    &:nth-child(1) {
                        padding-left: 20px;
                    }
                }
            }

            tbody {
                tr:nth-last-child(1) {
                    border-bottom: 1px solid #ebebeb;
                }

                td {
                    .del {
                        margin-left: 20px;
                    }

                    padding: 6px 0;
                    height: 60px;

                    &:nth-child(1) {
                        padding-left: 20px;
                    }

                    p,
                    .p {
                        padding: 10px 0;
                        margin: 0;
                        border-bottom: 1px solid #ebebeb;

                        &:nth-last-child(1) {
                            border: 0 none;
                        }
                    }
                }
            }
        }
    }
}

.modal-footer {
    text-align: center;

    .cancel {
        background-color: #b2c9e1;
        border-color: #b2c9e1;
        margin-left: 30px;
    }
}

.pages {
    text-align: right;
}
</style>
